<template>
	<div>
		<div v-if="authCheck" class="add-comment border p-4 mt-8 border-primary-100 leading-loose">
			<h5 class="text-sm text-secondary-200 font-bold">{{ t('leave_comment') }}</h5>
			<div class="control">
				<textarea class="form-textarea mt-3 mb-1 block w-full border-secondary-300" rows="5" name="comment" v-model="form.comment" v-validate="{ required: true }" :placeholder="t('comment_text')"></textarea>
				<p v-show="errors.has('comment')" class="text-red-500 text-sm mt-1">{{ errors.first('comment') }}</p>
			</div>
			<div class="add-rate">
				<star-rating v-model="form.rate" name="rate" :read-only= false  :star-size="25" active-color="#9a6600" inactive-color="#fff" :border-width="2" border-color="#9a6600"  :rtl="true" :show-rating="false" :rounded-corners="true" v-validate="{ min_value: 1 ,  max_value:5 }"></star-rating>
				<p v-show="errors.has('rate')" class="text-red-500 text-sm mt-1">{{t('rate_required')}}</p>
			</div>
			<div class="rtl:text-left ltr:text-right">  
				<button type="submit" v-if="edit" class="button bg-secondary-300 text-white text-sm" @click="updateComment(this.commentIndex)">تعديل التعليق</button>
				<button type="submit" v-if="edit" class="button bg-red-500 text-white text-sm" @click="cancelEdit">إلغاء</button>
				<button type="submit" v-if="!edit" class="button bg-secondary-300 text-white text-sm new_comment" @click="SubmitForm">{{ t('leave_comment') }}</button>
			</div>
		</div>
		<div v-for="(comment, key) in comments" :key="comment.id" class="comment border p-4 mt-4 rounded-lg leading-loose">
			<div class="flex justify-between">
				<h5 class="name text-primary font-semibold"><i class="fas fa-user-alt rtl:ml-2 ltr:mr-2"></i>{{ comment.user }}</h5>
				<ul class="flex">
					<li class="text-gray-500 text-xs font-semibold self-center mx-1">{{ comment.date }}</li>
					<li class="text-secondary-300 mx-1">
						<a v-if="authRole == 'admin'" @click.prevent="editComment(comment, key)"><i class="fas fa-edit"></i></a>
					</li>
					<li class="text-secondary-300 mx-1">
						<a v-if="authRole == 'admin'"  @click.prevent="deleteComment(comment.deleteLink, key)"><i class="fas fa-trash-alt"></i></a>
					</li>
				</ul>
			</div>
			
			<div class="rate">
				<star-rating  :read-only= true :rating=" comment.rate"  :star-size="18" active-color="#9a6600" inactive-color="#fff" :border-width="2" border-color="#9a6600"  :rtl="true" :show-rating="false" :rounded-corners="true" ></star-rating>
			</div>
			<div class="content mt-3 text-secondary-300">
				{{ comment.comment }}
			</div>
		</div>
	</div>

</template>
<script>
	import axios from 'axios';
	import StarRating from 'vue-star-rating/src/index';
	import arabic from 'vee-validate/dist/locale/ar';
	import { Validator , mapFields} from 'vee-validate';
	export default {
		name: "Comments",
		components:{
			StarRating
		},
		props: {
			action: {
				type: String,
				required: true
			},
			sitelocale:{
				type: String,
				required: true
			},
			authCheck:{
				type: String,
				required: true
			},
			product:{
				type: Object,
				required: true,
			},
			authRole:{
				type: String,
			},
		},
		data() {
			return {
				form : {
					comment:'',
					rate:0
				},
				comments: {},
				edit:false,
				comment: {},
				commentIndex:0
			};
		},
		mounted() {
			this.comments = this.product.comments;			
			this.$translate.setLang(this.sitelocale);
		},
		created() {
			this.$validator.localize('ar', {
				messages: arabic.messages,
				attributes: this.translate.ar,
				custom:this.translate.ar.custom
			});
			this.$validator.localize('en', {
				custom:this.translate.en.custom
			});

			Validator.localize(this.sitelocale);
		},
		methods: {
			SubmitForm(){
				this.$validator.validateAll().then((result) => {
					if (result) {
						const action = this.action;
						console.log(this.form);
						axios.post(action, this.form)
						.then( response => {
							this.$toasted.success(response.data.message);
							this.form.comment = '';
							this.form.rate = 0;
							this.success = true;
							this.comments.unshift(response.data.comment)
						})
						.catch(error => {
							let toaster = this.$toasted;
							$.each(error.response.data.errors, function(key, value) {
								toaster.error(value.message);
							});
							this.success = false;

						})
						.then(()=>{
							this.submitting = false;
							setTimeout(()=>{
								this.success = false;
							}, 3500);
						});

					}

				});

			},
			deleteComment(deleteLink, id){
				axios.delete(deleteLink)
				.then( response => {
					this.$toasted.success(response.data.message);
					this.success = true;
					this.$delete(this.comments, id);
				})
				.catch(error => {
					let toaster = this.$toasted;
					$.each(error.response.data.errors, function(key, value) {
						toaster.error(value.message);
					});
					this.success = false;

				})
				.then(()=>{
					this.submitting = false;
					setTimeout(()=>{
						this.success = false;
					}, 3500);
				});
			},
			editComment(comment, id) {
				this.commentIndex = id;
				this.comment = comment;
				this.edit = true;
				this.form.comment= comment.comment;
				this.form.rate = comment.rate;
				this.$delete(this.comments, id);
			},
			updateComment(id) {
				axios.patch(this.comment.editLink, this.form)
				.then( response => {
					this.$toasted.success(response.data.message);
					this.success = true;
					this.comments.splice(id, 0, response.data.comment);
					this.comment = {};
					this.commentIndex =0;
					this.edit = false;
					this.form.comment = '';
					this.form.rate = 0;
				})
				.catch(error => {
					let toaster = this.$toasted;
					$.each(error.response.data.errors, function(key, value) {
						toaster.error(value.message);
					});
					this.success = false;

				})
				.then(()=>{
					this.submitting = false;
					setTimeout(()=>{
						this.success = false;
					}, 3500);
				});
			},
			cancelEdit(){
				this.comments.splice(this.commentIndex, 0, this.comment);
				this.comment = {};
				this.commentIndex =0;
				this.edit = false;
				this.form.comment = '';
				this.form.rate = 0;
			}
		},

	};
</script>



// WEBPACK FOOTER //
// resources/assets/js/front/components/SiteComponents/Product/Comments.vue